// Navigation helpers for the encounters (EHR) surface.
//
// The encounters surface is served at "/" (the encounter list / home) and
// "/chat/:id" (an open encounter). See CLAUDE.md "Routing & Modules".

/** True on the encounters surface: the list ("/") or an open encounter ("/chat/:id"). */
export function isEncountersRoute(pathname) {
  return pathname === "/" || pathname.startsWith("/chat");
}

/**
 * True when the global Header's mobile sidebar button should RETURN the user to
 * the encounter list and deselect the currently-open encounter.
 *
 * That button is shared across pages (its icon is set per-page via
 * `iconSidebar` — "stethoscope" on Home/encounters, "menu_open" on Settings).
 * Deselecting the encounter (which unmounts ChatDetail and its sticky
 * patient-name header) must therefore only happen when BOTH:
 *   1. we're on the encounters surface, and
 *   2. an encounter is actually selected.
 * On any other surface — or with no encounter open — the button stays a plain
 * drawer toggle, so it never yanks a Settings/peptides/orders user back home.
 */
export function shouldReturnToEncounterList(pathname, hasSelectedChat) {
  return isEncountersRoute(pathname) && !!hasSelectedChat;
}
